// import React from "react";
import "./EducationTwoTeacher.scss";

const EducationTeacher = () => {
  const teachers = [
    {
      id: 1,
      name: "Dr. Sarah Johnson",
      subject: "Mathematics",
      experience: "15 years",
      rating: 4.9,
      image:
        "https://images.unsplash.com/photo-1580894732444-8ecded7900cd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&h=600&q=80",
    },
    {
      id: 2,
      name: "Prof. Michael Chen",
      subject: "Physics",
      experience: "12 years",
      rating: 4.8,
      image:
        "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&h=600&q=80",
    },
    {
      id: 3,
      name: "Dr. Priya Patel",
      subject: "Chemistry",
      experience: "10 years",
      rating: 4.7,
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&h=600&q=80",
    },
    {
      id: 4,
      name: "Prof. David Wilson",
      subject: "Computer Science",
      experience: "18 years",
      rating: 5.0,
      image:
        "https://images.unsplash.com/photo-1544717305-2782549b5136?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&h=600&q=80",
    },
  ];

  return (
    <section className="education-two-teacher-section education_two_sect_padding">
      <div className="container">
        <div className="teacher-container">
          <div className="teacher-content">
            <div className="content-wrapper">
              <span className="section-tag">World-Class Faculty</span>
              <h3 className="sect_title">
                <div className="h3_inner">
                  Learn From Industry{" "}
                  <span className="relative">
                    Experts.
                    <span class="title-shape">
                      <svg
                        width="150"
                        height="65"
                        viewBox="0 0 168 65"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="highligt_text"
                      >
                        <path
                          d="M73.3761 8.49147C78.4841 6.01353 82.5722 4.25154 88.8933 3.3035C94.2064 2.50664 99.6305 2.0701 104.981 1.94026C120.426 1.56549 135.132 4.90121 146.506 9.70405C158.628 14.8228 166.725 22.5638 166.074 31.6501C165.291 42.5779 151.346 51.7039 133.508 56.8189C110.253 63.4874 81.7065 63.8025 58.5605 60.8285C37.5033 58.123 11.6304 51.7165 3.58132 40.0216C-3.43085 29.8337 12.0728 18.1578 27.544 11.645C40.3656 6.24763 55.7082 2.98328 70.8043 4.08403C81.9391 4.89596 93.2164 6.87822 102.462 9.99561C112.874 13.5066 120.141 18.5932 127.862 23.6332"
                          stroke="var(--click-color)"
                          stroke-width="3"
                          stroke-linecap="round"
                        ></path>
                      </svg>
                    </span>
                  </span>
                </div>
              </h3>

              <div className="stats-container">
                <div className="stat-item">
                  <div className="stat-number">200+</div>
                  <div className="stat-label">Certified Tutors</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">Success Rate</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">4.9/5</div>
                  <div className="stat-label">Average Rating</div>
                </div>
              </div>

              <p className="description">
                Our faculty members hold advanced degrees from top institutions
                and bring years of practical experience. They're not just
                teachers - they're mentors dedicated to your success.
              </p>

              <div className="cta-group">
                <button className="primary-cta">
                  Explore Programs
                  <span className="icon-arrow">→</span>
                </button>
                <button className="secondary-cta">Meet All Faculty</button>
              </div>

              <div className="testimonial">
                <div className="quote-icon">"</div>
                <p className="quote-text">
                  The quality of instructors at this institution is
                  unparalleled. Their personalized approach made all the
                  difference in my learning.
                </p>
                <div className="quote-author">- Priya Sharma, Alumni</div>
              </div>
            </div>
          </div>

          {/* Scrollable Teacher Gallery */}
          <div className="teacher-gallery">
            <div className="gallery-scroll">
              {teachers.map((teacher) => (
                <div className="teacher-card" key={teacher.id}>
                  <div className="card-image">
                    <img
                      src={teacher.image}
                      alt={teacher.name}
                      loading="lazy"
                    />
                    <div className="card-badge">
                      <span className="rating">{teacher.rating}</span>
                      <span className="star">★</span>
                    </div>
                  </div>
                  <div className="card-content">
                    <h3>{teacher.name}</h3>
                    <p className="subject">{teacher.subject}</p>
                    <p className="experience">
                      {teacher.experience} experience
                    </p>
                    <button className="profile-button">View Profile</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationTeacher;
